<template>
  <div
    class="chat-simple-text chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    {{ message.DATA_TEXT }}
    <template v-if="message.inapp_links">
      <div class="buttons-wrapper">
        <oeamtc-link-button
          :href="link.url"
          target="_blank"
          v-for="(link, index) in message.inapp_links"
          :key="index"
        >
          {{ link.title }}
        </oeamtc-link-button>
      </div>
    </template>
    <template v-if="message.location">
      <MglMap
        :accessToken="accessToken"
        :dragPan="false"
        class="message-map"
        :scrollZoom="false"
        :mapStyle="mapStyle"
        :center="[message.location.lon, message.location.lat]"
        :zoom="15"
      >
        <MglMarker
          :coordinates="[message.location.lon, message.location.lat]"
          color="#404040"
        />
      </MglMap>
    </template>
  </div>
</template>

<script>
import MessageDate from '../MessageDate.vue';
import { MglMap, MglMarker } from 'vue-mapbox';
import { OeamtcLinkButton } from '@oeamtc/styleguide-vuejs-lib-ui';

export default {
  name: 'SimpleText',
  props: ['message', 'messageIndex'],
  components: {
    MessageDate,
    OeamtcLinkButton,
    MglMap,
    MglMarker,
  },
  data() {
    return {
      accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
      mapStyle: process.env.VUE_APP_MAPBOX_STYLE,
    };
  },
};
</script>

<style lang="scss" scoped>
.buttons-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  a {
    margin: 5px 0;
    // padding-left: 0;
    // padding-right: 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.chat-simple-text {
  white-space: pre-line;
}
.message-map {
  height: 300px;
  border-radius: $default-radius;
  overflow: hidden;
}
</style>
